import { h } from 'preact';
import dlv from 'dlv';
import { Text } from 'preact-i18n';

/**
 * Convert config params to a query-string for SCS
 * @param {} obj An object of parameters
 */
export function serialize(obj) {
	if (Object.keys(obj).length === 0) return '';

	let str = '?' + Object.keys(obj).reduce((arr, i) => {
		arr.push(i + '=' + encodeURIComponent(obj[i]));
		return arr;
	}, []).join('&');
	return str;
}

export function getAssetType(asset) {
	if (asset.videos && asset.videos.length > 0) return 'video';
	if (dlv(asset, 'metadata.attribution.vendor') === 'Slideshow') return 'slideshow';
	return 'headline';
}

export function isExternal(article) {
	return dlv(article, 'link.external') || dlv(article, 'href', '').startsWith('http');
}

export function getAttribution(asset) {
	let attribution = dlv(asset, 'metadata.attribution.vendor');

	if (attribution && asset.isSponsored) {
		return <Text id="sponsoredAttribution" fields={{ attribution }} />;
	}
	return attribution;
}

export function replaceNthOccurance(original, match, replacement, occurance) {
	let nth = 0,
		re = new RegExp(match, 'g');
	return original.replace(re, (m, i) => {
		nth++;
		return (nth === occurance) ? replacement : m;
	});
}

// unbiased shuffle algorithm: the Fisher-Yates (aka Knuth) Shuffle.
export function shuffle(array) {
	if (!array || array.length === 0) return array;

	let currentIndex = array.length, temporaryValue, randomIndex;

	// While there remain elements to shuffle...
	while (0 !== currentIndex) {

		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;

		// And swap it with the current element.
		temporaryValue = array[currentIndex];
		array[currentIndex] = array[randomIndex];
		array[randomIndex] = temporaryValue;
	}

	return array;
}

export function parseQueryString() {
	let str = window.location.search,
		objURL = {};

	str.replace(
		new RegExp( '([^?=&]+)(=([^&]*))?', 'g' ),
		( $0, $1, $2, $3 ) => {
			objURL[ $1 ] = $3;
		}
	);
	return objURL;
}

export function getCtaText(asset) {
	if (dlv(asset, 'videos.0'))  return <Text id="watch" />;
	if (dlv(asset, 'metadata.attribution.vendor') === 'iMDS Shopping')  return <Text id="readGuide" />;
	if (dlv(asset, 'metadata.attribution.vendor') === 'Arkadium')  return <Text id="playNow" />;
	return <Text id="read" />;
}

const BLACKLIST_VENDOR = [
	'iMDS Shopping',
	'Arkadium'
];
export function getHybridAttribution(asset) {
	let vendor = dlv(asset, 'metadata.attribution.vendor');

	if (BLACKLIST_VENDOR.includes(vendor)) return '';

	return vendor;
}
